import React, { useState } from "react";
import './register-clinic.css';
import {
    Button,
    Form,
    Col,
    Row,
    Container,
  } from "react-bootstrap";
import {useForm} from "react-hook-form";
import axios from 'axios';
import SyncLoader from "react-spinners/SyncLoader";
import GenericModal from '../../modals/check-your-email';
import ReactGA from 'react-ga';



export default function RegisterClinic() {
    ReactGA.pageview(window.location.pathname + window.location.search);
    const [loading, setLoading] = useState(false);
    const [success, setSuccess] = useState(false);
    const [show, setShow] = useState(false);
    const [emailAlreadyExists, setEmailAlreadyExists] = useState(false);

    const {register, handleSubmit} = useForm();

    const onSubmit = async (data) => {
        setLoading(true);
        setEmailAlreadyExists(false);
        const emailTaken = await axios.post('https://uae-dentist-backend.herokuapp.com/check-email-availability', {email: data.email});
        console.log(emailTaken);
        if(emailTaken.data.emailExist){
            console.log('hello')
            setEmailAlreadyExists(true);
            setLoading(false);
            return;
        }
        axios.post('https://uae-dentist-backend.herokuapp.com/register', data)
        .then(function (response1) {
            console.log(response1);
            axios.post('https://uae-dentist-backend.herokuapp.com/mail/welcome', response1.data)
            .then(function(response2){
                console.log(response2)
                setLoading(false);
                setShow(true);
                setSuccess(true);
            })
            .catch(function (error) {
                setLoading(false);
                setShow(true);
                setSuccess(false);
                console.log(error);
            })
        })
        .catch(function (error) {
            setLoading(false);
            setShow(true);
            setSuccess(false);
            console.log(error);
        });
    }

    return (
    <Container className="mt-5 rounded">
    { show && <GenericModal setShow={setShow} show={show} success={success}/>}
    <Row>
    <Col id="message" className="rounded p-5 mt-2 mb-2">
        Feel free to add as many clinics as you want.
        <br/>
        <br/>
        <h6>There will be more functionalities added soon. Feel free to give us feedback.
            <br/>
            <br/>
            Our simple service makes it easier for you to add information about your clinic - all around the clock. 
            Add your clinic today so that we can start showing it to customers.
            <br/>
            <br/>
            Welcome to AUE.dentist!
        </h6>
    </Col>
    <Col id="form" className="p-5 rounded">
    <Form onSubmit={handleSubmit(onSubmit)}>

        <Form.Group >
            <Form.Label>Name of Clinic*</Form.Label>
            <Form.Control required placeholder="Name of Clinic" name="clinic_name" ref={register ({required:true})}/>
        </Form.Group>

        <Form.Group controlId="emirate">
        <Form.Label>Emirate*</Form.Label>
            <Form.Control as="select" name="emirate" ref={register ({required:true})} custom>
            <option>- Please Select -</option>
            <option>Dubai</option>
            <option>Abu Dhabi</option>
            <option>Sharjah</option>
            <option>Ajman</option>
            <option>Fujairah</option>
            <option>Ras Al Khaimah</option>
            <option>Umm Al Quwain</option>
            </Form.Control>
        </Form.Group>

        <Form.Group >
            <Form.Label>Contact Person*</Form.Label>
            <Form.Control required placeholder="Full Name" name="contact_person" ref={register ({required:true})}/>
        </Form.Group>

        <Form.Group>
            <Form.Label>Email*</Form.Label>
            <Form.Control required placeholder="Email" type="email" name="email" ref={register ({required:true})} />
        </Form.Group>

        <Form.Group >
            <Form.Label>Password*</Form.Label>
            <Form.Control required placeholder="Password" type="password" name="password" ref={register ({required:true})}/>
        </Form.Group>
        {emailAlreadyExists && <p className="text-danger">An account with that email already exists.</p>}
        <Button variant="primary" type="submit">
            Register
        </Button>

        <div className='mt-5'>
          <SyncLoader
            size={15}
            margin={2}
            color={"#123abc"}
            loading={loading}
          />
        </div>
    </Form>
    
    </Col>
    </Row>
    
    </Container>
    )
}